module.exports = __webpack_public_path__ + "media/components/country-flag/static/ma-49581a62c5a980a7f0ccaad15734afd8.svg";